module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Logo_01.e51c99e0.png";